import { Chip } from "@material-ui/core";
import BoletoDownloadIconButton from "components/_refactor/buttons/boleto-download-icon-button";
import { columnTextField, columnNumberField } from "utils/tables-utils";
import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import { LONGTERM_STATUS } from "../view/titulos-financeiros";

function sortableDateValue(cell) {
  if (cell == null || cell === "") return "";
  const s = String(cell).trim();
  if (s.length === 10 && s.includes("-")) return s.replace(/-/g, "");
  const br = s.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (br) return `${br[3]}${br[2]}${br[1]}`;
  return s;
}

export default function TableTitulos({ data, totalRegistros, extraActions }) {
  const columnModel = [
    columnTextField({
      dataField: "Boleto",
      text: "Boleto",
      align: "center",
      formatter: (_, row) => (
        <BoletoDownloadIconButton
          row={row}
          origem="lojista-360"
          icon="document"
        />
      ),
    }),
    columnNumberField({
      dataField: "NumeroTitulo",
      text: "Nr Título",
    }),
    columnTextField({
      dataField: "Situacao",
      text: "Situação",
      align: "center",
      formatter: (_, row) => {
        const status = row.Situacao === "LQ" ? true : false;
        return (
          <Chip
            label={LONGTERM_STATUS.get(row.Situacao)}
            size="small"
            style={{
              width: "100px",
              padding: "1rem 0.5rem",
              backgroundColor: status
                ? "rgba(0, 128, 0, 0.1)"
                : "rgba(255, 215, 0, 0.1)",
              border: status
                ? "1px solid rgba(0, 128, 0, 0.5)"
                : "1px solid rgba(255, 215, 0, 0.5)",
            }}
          />
        );
      },
    }),
    columnTextField({
      dataField: "DataEmissao",
      text: "Emissão",
      align: "center",
      sort: true,
      sortValue: (cell) => sortableDateValue(cell),
    }),
    columnTextField({
      dataField: "DataVencimentoProrrogado",
      text: "Vencimento",
      align: "center",
      sort: true,
      sortValue: (cell) => sortableDateValue(cell),
    }),
    columnTextField({
      dataField: "Valor",
      text: "Valor",
      align: "end",
      formatter: (value) => `R$ ${value}`,
    }),
    columnTextField({
      dataField: "ValorEmAberto",
      text: "Valor em Aberto",
      align: "end",
      formatter: (value) => `R$ ${value}`,
    }),
    columnTextField({
      dataField: "Marca",
      text: "Marca",
      align: "center",
    }),
  ];

  return (
    <ToolkitTable
      dataTable={data}
      columnModel={columnModel}
      keyField="IdTitulo"
      showPrint
      extraActions={extraActions}
      pagination={{
        options: [10, 25, 50, 100],
        defaultOption: 10,
        totalSize: totalRegistros,
        showTotal: true,
      }}
      style={{
        boxShadow: "none",
        margin: "0 -1rem",
      }}
    />
  );
}
